require('./openYoungCardRejectSavingsView.scss');

// @vendor
const PropTypes = require('prop-types');
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
//@ Commons
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @actions
const cardChargeActions = require('actions/cardCharge');
const openYoungCardSavings = require('actions/openYoungCardSavings');

// @components
const { LoadingSection } = require('commonsComponents/loadingSection');
const CardSavingsReject = require('components/cards/cardSavingsReject/cardSavingsReject');
const CardChargeSuccessStep = require('components/cards/cardChargeSteps/cardChargeSuccessStep/cardChargeSuccessStep');
const CardChargeErrorStep = require('components/cards/cardChargeSteps/cardChargeErrorStep/cardChargeErrorStep');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const CardHeaderDetails = require('components/cards/cardHeaderDetails/cardHeaderDetails');

// @utilities
const { cardConstants } = require('utilities/accessHelperConditions/cards');
const AccessHelper = require('utilities/accessHelper');

// @constants
const {
    GRAPHIC_TUTOR_TYPE_4,
    REJECT_MONEY_REQUEST_STATUS,
    CARD_CHARGE_SAVINGS_OPERATION_REJECT
} = require('constants/index');

class OpenYoungCardRejectSavingsView extends React.Component {
    constructor(props) {
        super(props);
        this.rejectMoneyRequestCall = this.rejectMoneyRequestCall.bind(this);
    }

    componentDidMount() {
        const {
            history,
            match: { params: { cardId } },
            requestECardInfo,
            immCards,
            openYoungCardSavings,
            setOperationType,
            setAmount
        } = this.props;
        const amountRequested = openYoungCardSavings.getIn(['savingsDetail', 'requestAmount']);
        const immCard = immCards.getIn(['byId', cardId]);

        AccessHelper.allowAccess(cardConstants.CARD_CHARGE, { immCard }, history);
        requestECardInfo(cardId);

        setOperationType(CARD_CHARGE_SAVINGS_OPERATION_REJECT);
        setAmount(amountRequested);
    }

    componentWillUnmount() {
        this.props.clearRequest();
    }

    rejectMoneyRequestCall() {
        const { match: { params: { cardId } }, rejectMoneyRequestCall } = this.props;
        rejectMoneyRequestCall(cardId, REJECT_MONEY_REQUEST_STATUS);
    }

    render() {
        const {
            match: { params: { cardId } },
            immCards,
            immCardCharge,
            requestECardInfo,
            immAccounts,
            openYoungCardSavings
        } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        const moneyRequestDetails = openYoungCardSavings.get('savingsDetail');
        const isRejecting = openYoungCardSavings.get('isRejectingSavingsRequest');
        const submitSuccessful = openYoungCardSavings.get('submitSuccessful');
        const isFetching = openYoungCardSavings.get('isFetching');
        const amountRejected = moneyRequestDetails.get('requestAmount');

        const childName = immCard.get('beneficiaryNameOnCard').replace(/\*/g, ' ');
        const mappingBreadcrumb = [
            {
                text: formatText('moneySavingsRequest-cancelBreadcrumbText'),
                url: ''
            }
        ];
        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_4}
                title={formatText('moneySavingsRequest-cancelTitle')}
            />
        );

        let bodyContent;
        if (isFetching) {
            bodyContent = <LoadingSection />
        } else if (submitSuccessful) {
            bodyContent = (
                <CardChargeSuccessStep
                    immAccounts={immAccounts}
                    immCard={immCard}
                    immCardCharge={immCardCharge}
                    loading={immCardCharge.get('isFetching')}
                    requestEcardInfo={requestECardInfo}
                />
            );
        } else if (immCardCharge.get('blockFlow')) {
            bodyContent = <CardChargeErrorStep immCard={immCard} />;
        } else {
            bodyContent = (
                <div>
                    <div className="col-xs-12 col-md-12">
                        <CardSavingsReject
                            immCard={immCard}
                            amountRejected={amountRejected}
                            beneficiary={childName}
                            rejectMoneyRequestCall={this.rejectMoneyRequestCall}
                            cardId={cardId}
                            isRejecting={isRejecting}
                        />
                    </div>
                </div>
            );
        }

        return (
            <div className="openyoung-card-reject-savings-view">
                <div className="container-fluid card-charge-view--header-identifier">
                    <div className="row">
                        <OKCover size="medium" section="cards" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                tutorial={tutorial}
                                finalTitle={getFinalTitle('moneySavingsRequest-cancelTitle')}>
                                <CardHeaderDetails
                                    immCard={immCard}
                                    isFetching={immCardCharge.get('isFetching')}
                                />
                            </OKHeaderSubPage>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {bodyContent}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

OpenYoungCardRejectSavingsView.propTypes = {
    clearRequest: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCardCharge: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    openYoungCardSavings: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    requestECardInfo: PropTypes.func.isRequired,
    rejectMoneyRequestCall: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    setOperationType: PropTypes.func.isRequired,
    setAmount: PropTypes.func,
    validateStep: PropTypes.func.isRequired
}

module.exports.Constructor = OpenYoungCardRejectSavingsView;
module.exports.OpenYoungCardRejectSavingsView = connect(
    state => ({
        immCards: state.cards,
        immCardCharge: state.cardCharge,
        immAccounts: state.accounts,
        openYoungCardSavings: state.openYoungCardSavings
    }),
    {
        clearRequest: cardChargeActions.clearRequest,
        rejectMoneyRequestCall: openYoungCardSavings.rejectMoneyRequestCall,
        requestECardInfo: cardChargeActions.requestECardInfo,
        setVisibleStep: cardChargeActions.setVisibleStep,
        setWillCancel: cardChargeActions.setWillCancel,
        setOperationType: cardChargeActions.setOperationType,
        setAmount: cardChargeActions.setAmount,
        validateStep: cardChargeActions.validateStep

    })(withRouter(OpenYoungCardRejectSavingsView));
